import React from "react";
import _ from "underscore";
import { isNotEmpty } from "../../../framework/utils";
import M from "../../../strings";
import { MaterialIcon } from "../materialIcon";

export default class Searchbar extends React.Component {

    constructor(props) {
        super(props);
        this.onChange = _.debounce(this._onChange, this.props.debounceWait || 500);
    }

    _onChange(value) {
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(value);
        }
    }

    render() {
        let className="searchbar__wrapper";
        
        if (isNotEmpty(this.props.className)) {
            className += " " + this.props.className;
        }

        return(
            <div
                className={className}
            >
                <MaterialIcon
                    className="searchbar__search"
                    icon="search"
                />
                <input
                    className="searchbar__input"
                    onChange={(e) => this.onChange(e.target.value)}
                    placeholder={M("searchbarPlaceholder")}
                />
            </div>
        )
    }
}